import React, { useCallback } from 'react'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,

    display: 'block',

    padding: '14px 45px',
    marginLeft: 'auto',
    marginRight: 'auto',

    borderRadius: 28,
    border: '1px solid rgb(88, 77, 226)',

    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 1,
    textTransform: 'uppercase',

    color: theme.palette.info.light,
    background: theme.palette.primary.light,
    '&:hover': {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.info.main,
    },
  },
}))

type propTypes = {
  width: number | string
  mt?: number | string
  mb?: number | string
  type?: string
  href?: string
}

export const PurpleButton: React.FC<propTypes> = ({ children, width, mt, mb, type, href }) => {
  const classes = useStyles({ width, mt, mb, type, href })

  const pdfHandler = useCallback(() => {
    window.open(href)
  }, [href])

  return (
    <Button variant="contained" type="submit" onClick={pdfHandler} className={classes.button}>
      {children}
    </Button>
  )
}
